export enum SessionLogMessages {
  START_TAKING_CALLS_CLICK = 'Start taking calls click',
  FINISH_TAKING_CALLS_SUCCESS = 'Finish taking calls success',
}
